import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ApolloLink} from '@apollo/client';
import {
  CORE_INSURERS_WITH_ACTIVE_LOB,
  GET_ALL_INSURERS,
  INSURERS_WITH_ACTIVE_LOBS_AND_AVAILABLE_PRODUCT,
} from '../queries/insurer.query.model';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiInsurerService {

  private apiGraphqlService = inject(ApiGraphqlService);

  /**
   * Method API: Get all insurers (used query)
   * @return: Observable
   */
  getAllInsurersObservable(): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(GET_ALL_INSURERS);
  }

  /**
   * Method API: Get core insurers with active lob (used query)
   * @param lobId
   * @param contractTypes
   * @return: Observable
   */
  getCoreInsurersWithActiveLobObservable(
    lobId: number,
    contractTypes: string[],
  ): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(CORE_INSURERS_WITH_ACTIVE_LOB, {lobId, contractTypes});
  }

  /**
   * Method API: Get list of active (not deleted) Insurers with active LoBs and at least one available Product.
   * Product can be hidden only in scope of Insurer Interview feature.
   * In case of Pension check against all Contract Types.
   * In case of Pension LoB, pension types required.
   * Access: Any authenticated. (used query)
   * @param lobIds
   * @param contractTypes
   * @param interPension
   * @return: Observable
   */
  getInsurersWithActiveLobsAndAvailableProductObservable(
    lobIds: string[],
    contractTypes: string[],
    interPension: boolean,
  ): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(
      INSURERS_WITH_ACTIVE_LOBS_AND_AVAILABLE_PRODUCT,
      {lobIds, contractTypes, interPension},
    );
  }

}
